import '../../sass/blocks/stats.scss';

class RollCounter {
    constructor(container, options = {}) {
        this.container = typeof container === 'string' ? document.querySelector(container) : container;
        if (!this.container) return;

        this.options = {
            duration: options.duration || 1200,
            delay: options.delay || 0,
            staggerDelay: options.staggerDelay || 45,
            easing: options.easing || 'cubic-bezier(0.16, 1, 0.3, 1)',
            digitSelector: options.digitSelector || '.digit, [data-target]',
            ...options
        };

        this.init();
    }

    init() {
        // Find all digit spans with target attributes
        this.digitSpans = Array.from(this.container.querySelectorAll(this.options.digitSelector));
        
        this.digitSpans.forEach((span) => {
            // Read target from attribute
            const targetVal = span.getAttribute('data-target') || span.textContent.trim();
            span.setAttribute('data-target', targetVal);
            
            // Clear span and build 0-9 strip
            span.innerHTML = '';
            span.classList.add('digit-roll');

            const strip = document.createElement('div');
            strip.className = 'digit-strip';

            for (let i = 0; i <= 9; i++) {
                const valDiv = document.createElement('div');
                valDiv.className = 'digit-val';
                valDiv.textContent = i;
                strip.appendChild(valDiv);
            }

            span.appendChild(strip);
        });

        this.startAnimation();
    }

    startAnimation() {
        this.digitSpans.forEach((span, index) => {
            const strip = span.querySelector('.digit-strip');
            if (!strip) return;

            const targetDigit = parseInt(span.getAttribute('data-target'), 10) || 0;
            const delay = index * this.options.staggerDelay + this.options.delay;

            // Reset to 0 position without transition
            strip.style.transition = 'none';
            strip.style.transform = 'translateY(0%)';

            // Double rAF ensures DOM paint before transition triggers
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    strip.style.transition = `transform ${this.options.duration}ms ${this.options.easing} ${delay}ms`;
                    strip.style.transform = `translateY(-${targetDigit * 10}%)`;
                });
            });
        });
    }

    updateOptions(newOptions) {
        this.options = { ...this.options, ...newOptions };
    }
}

(() => {
    const $blocks = document.querySelectorAll('.stats');

    if (!$blocks.length) return;

    $blocks.forEach($block => {
        const $inner = $block.querySelector('.stats__inner');
        const $statNumbers = $block.querySelectorAll('.stats__stat-number');

        const statNumbers = () => {
            $statNumbers.forEach($statNumber => {
                const { delay } = $statNumber.dataset;

                new RollCounter($statNumber, {
                    delay: delay * 1000,
                    staggerDelay: 100
                });
            });
        };

        const initStatNumbers = () => {
            if ($inner.classList.contains('is-on-screen')) {
                statNumbers();
            }

            $inner.addEventListener('onScreen', () => {
                statNumbers();
            });
        };

        initStatNumbers();
    });
})();
